import AbstractService from '@/services/abstractService'

class AreasService extends AbstractService {
  endpoint = 'areas'

  index() {
    return this.http.get(`${this.endpoint}`, { params: { dashboard: true } })
  }

  delete(data) {
    return this.http.delete(`${this.endpoint}/${data}`)
  }


  post(data) {
    // define append form
    const formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.post(this.endpoint, formData)
  }

  put(data) {
    // define append form
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.put(`${this.endpoint}/${data.id}`, formData)
  }

}

const Service = new AreasService()

export default Service
